// These are ported from monolith /inc/permissions.php
// To unify the naming in SPA, constant should be prefixed with CAN_ even if it differs with /inc/permissions.php
// Please keep these files synced if making changes

export const Permission = {
	IS_SUPER_ADMIN: 'is_super_admin',
	IS_ADMIN: 'is_admin',

	CAN_CREATE_COMPANY: 'cancreate_company',
	CAN_DELETE_COMPANIES: 'candelete_companies',
	CAN_SEE_OTHER_COMPANIES: 'cansee_otherscompanies',
	CAN_CHANGE_OTHER_COMPANIES: 'canchange_otherscompanies',
	CAN_CHANGE_OTHER_RELATED_COMPANIES: 'canchange_others_related_companies',
	CAN_SEE_OTHER_COMPANIES_INLISTS: 'cansee_otherscompanies_inlist',

	CAN_CREATE_PERSON: 'cancreate_person',
	CAN_DELETE_PERSONS: 'candelete_persons',
	CAN_SEE_OTHER_PERSONS: 'cansee_otherspersons',
	CAN_CHANGE_OTHER_PERSONS: 'canchange_otherspersons',
	CAN_CHANGE_OTHER_RELATED_PERSONS: 'canchange_others_related_persons',
	CAN_SEE_OTHER_PERSONS_INLISTS: 'cansee_otherspersons_inlist',

	CAN_DELETE_INVOICES: 'candelete_invoices',

	CAN_CREATE_PROJECTS: 'cancreate_projects',
	CAN_SEE_OTHER_PROJECTS: 'cansee_otherprojects',
	CAN_CHANGE_OTHER_RELATED_PROJECTS: 'canchange_others_related_projects',
	CAN_CHANGE_OTHER_PROJECTS: 'canchange_otherprojects',
	CAN_DELETE_PROJECTS: 'candelete_projects',
	CAN_SEE_PROJECT_INCOME_COST: 'cansee_project_income_cost',
	CAN_CHANGE_PROJECT_STATUS_TO_COMPLETED:
		'can_change_project_status_to_completed',
	CAN_SEE_ALL_PROJECT_RELATED_FINANCE_DOCUMENTS:
		'can_see_all_project_related_finance_documents',

	CAN_SEE_OTHER_DOCS: 'cansee_otherdocs',
	CAN_CHANGE_OTHER_DOCS: 'canchange_otherdocs',

	CAN_SEE_OTHER_QUOTES: 'cansee_otherquotes',
	CAN_SEE_OTHER_QUOTES_RELATED_TO_ME: 'cansee_otherquotes_related_to_me',
	CAN_CHANGE_QUOTES_WITH_ADDITIONAL_STATUSES:
		'canchange_quotes_with_additional_statuses',
	CAN_SET_ADDITIONAL_STATUSES: 'canset_additional_statuses',
	CAN_CONFIRM_QUOTES: 'canconfirm_quotes',
	CAN_CONFIRM_QUOTE_LINES: 'canconfirm_quote_lines',
	CAN_SET_STATUS_COMPLETED: 'canset_status_completed',
	CAN_CHANGE_CONFIRMED_QUOTES: 'canchange_confirmedquotes',
	CAN_CHANGE_QUOTES_TEMPLATES: 'canchange_quotes_templates',
	CAN_CREATE_QUOTES_TEMPLATES: 'cancreate_quotes_templates',
	CAN_CHANGE_OTHER_QUOTES: 'canchange_otherquotes',
	CAN_DELETE_QUOTES: 'candelete_quotes',

	CAN_SEE_OTHER_ORDERS: 'cansee_otherorders',
	CAN_SEE_OTHER_ORDERS_RELATED_TO_ME: 'cansee_otherorders_related_to_me',
	CAN_CHANGE_OTHER_ORDERS: 'canchange_otherorders',
	CAN_DELETE_ORDERS: 'candelete_orders',

	CAN_SEE_OTHER_PURCHASE_ORDERS: 'cansee_other_purchase_orders',
	CAN_SEE_OTHER_PURCHASE_ORDERS_RELATED_TO_ME:
		'cansee_other_purchase_orders_related_to_me',
	CAN_CHANGE_OTHER_PURCHASE_ORDERS: 'canchange_other_purchase_orders',
	CAN_DELETE_PURCHASE_ORDERS: 'candelete_purchase_orders',
	CAN_CREATE_PURCHASE_ORDERS: 'cancreate_purchase_orders',

	CAN_SEE_OTHER_BILLS: 'cansee_other_bills',
	CAN_SEE_OTHER_BILLS_RELATED_TO_ME: 'cansee_other_bills_related_to_me',
	CAN_CHANGE_OTHER_BILLS: 'canchange_other_bills',
	CAN_DELETE_BILLS: 'candelete_bills',
	CAN_CREATE_BILLS: 'cancreate_bills',

	CAN_SEE_OTHER_EXPENSES: 'cansee_other_expenses',
	CAN_SEE_OTHER_EXPENSES_RELATED_TO_ME: 'cansee_other_expenses_related_to_me',
	CAN_CHANGE_OTHER_EXPENSES: 'canchange_other_expenses',

	CAN_SEE_OTHER_RENT_ORDERS: 'cansee_otherrentorders',
	CAN_SEE_OTHER_RENT_ORDERS_RELATED_TO_ME:
		'cansee_otherrentorders_related_to_me',
	CAN_DELETE_RENT_ORDERS: 'candelete_rentorders',
	CAN_CHANGE_OTHER_RENT_ORDERS: 'canchange_otherrentorders',
	CAN_CANCONFIRM_RENTORDERS_WORKS: 'canconfirm_rentorders_works',
	CAN_CREATE_RENT_ORDERS: 'cancreate_rentorders',
	CAN_CHANGE_RENT_ORDERS_WORKERS: 'canchange_rentorders_workers',
	CAN_SEE_RENT_ORDERS_SUM: 'cansee_rentorderssum',
	CAN_SEE_RENT_ORDERS_PDF: 'cansee_rentorderspdf',

	CAN_SEE_OTHER_INVOICES: 'cansee_otherinvoices',
	CAN_SEE_OTHER_INVOICES_RELATED_TO_ME: 'cansee_otherinvoices_related_to_me',
	CAN_CREATE_INVOICE: 'cancreate_invoice',
	CAN_CHANGE_INVOICES: 'canchange_invoices',
	CAN_CREATE_OTHERS_INVOICES: 'cancreate_otherinvoices',
	CAN_CHANGE_OTHERS_INVOICES: 'canchange_otherinvoices',
	CAN_MARK_PAYMENTS: 'canmark_payments',
	CAN_LOCK_INVOICES: 'canlock_invoices',
	CAN_CHANGE_LOCKED_INVOICES: 'canchange_locked_invoices',
	CAN_LINK_TIME_BILLS_EXPENSES_EXISTING_INVOICES:
		'can_link_time_bills_expenses_existing_invoices',

	CAN_CHANGE_PRICE_IN_PTA: 'canchange_price_in_pta',

	CAN_SEE_OTHER_FILES: 'cansee_otherfiles',
	CAN_CHANGE_DELETE_OTHER_FILES: 'canchangedelete_other_files',
	CAN_DELETE_FILES: 'candelete_files',

	CAN_DELETE_OTHER_COMMENTS: 'candelete_othercomments',
	CAN_CHANGE_OTHER_COMMENTS: 'canchange_othercomments',

	CAN_UNASSIGNED_TASKS: 'unassigned_tasks',
	CAN_DELETE_TASKS_OWNED_BY_OTHERS: 'can_delete_tasks_owned_by_others',
	CAN_CONFIRM_TIME_ENTRIES_AND_CALENDAR_EVENTS:
		'can_confirm_time_entries_and_calendar_events',
	CAN_SEE_QUOTE_BUDGETED_HOURS_ON_TASKS:
		'can_see_quote_budgeted_hours_on_tasks',

	CAN_CHANGE_CALENDAR_RIGHTS: 'canchange_calendarrights',

	CAN_SET_OBJECTS: 'canset_objects',
	CAN_SET_STATUSES: 'canset_statuses',
	CAN_SET_VATS: 'canset_vats',

	CAN_EXPORT_DATA: 'canexport_data',

	CAN_SET_GENERAL_SETTINGS: 'canset_general_settings',
	CAN_SET_FINANCE_SETTINGS: 'canset_finance_settings',
	CAN_SET_EVENT_SETTINGS: 'canset_event_settings',
	CAN_MANAGE_CUSTOM_MODULES: 'canmanage_custom_modules',
	CAN_SET_PDF_TEMPLATES_CUSTOM_FIELDS: 'canset_pdf_templates_custom_fields',
	CAN_SET_PRODUCT_SETTINGS: 'canset_product_settings',
	CAN_SET_VALIDATION_SETTINGS: 'canset_validation_settings',
	CAN_CHANGE_ALL_BOOKMARKS: 'canchange_all_bookmarks',
	CAN_CHANGE_ROLES: 'can_change_roles',

	CAN_SEE_ARTIST_REPORT: 'cansee_artistreport',
	CAN_SEE_CLIENT_STATS: 'cansee_clientstats',
	CAN_SEE_WORK_SUMMARY_REPORT: 'cansee_monthlyreport',
	CAN_SEE_SALES_REPORT: 'cansee_salesreport',
	CAN_SEE_SALESTEAM_REPORT: 'cansee_salesteamreport',
	CAN_SEE_REVENUE_REPORT: 'cansee_revenuereport',
	CAN_SEE_BUDGET_REPORT: 'cansee_budgetreport',
	CAN_SEE_OBJECT_REPORT: 'cansee_objectreport',
	CAN_SEE_MARGIN_REPORT: 'cansee_marginreport',
	CAN_SEE_RENT_ORDERS_REPORT: 'cansee_rentordersreport',
	CAN_SEE_WIP_REPORT: 'cansee_wipreport',
	CAN_SEE_END_PRICE_IN_WORKREPORT: 'cansee_end_price_in_workreport',
	CAN_SEE_OTHER_WORKREPORT: 'cansee_workreport',
	CAN_SEE_OTHER_LABORCOST: 'cansee_otherlaborcost',
	CAN_SEE_MARGIN_AND_MARKUP: 'cansee_margin_and_markup',
	CAN_SEE_OTHER_SENDLOG: 'cansee_sendlog',
	CAN_SEE_REAL_ESTATE_REPORT: 'cansee_real_estate_report',
	CAN_SEE_BONUS_REPORT: 'cansee_bonusreport',
	CAN_SEE_PROJECT_STATUS_REPORT: 'cansee_project_status_report',
	CAN_SEE_PIPELINE_REPORT: 'cansee_pipeline_report',
	CAN_SEE_PREPAYMENT_BALANCE_REPORT: 'cansee_prepayment_balance_report',

	CAN_DELETE_OTHER_USERS_POSTS: 'candelete_other_users_posts',

	CAN_ACTIVATE_RE_OBJECTS: 'canactivate_reobjects',
	CAN_ARCHIVE_RE_OBJECTS: 'canarchive_reobjects',
	CAN_CHANGE_ARCHIVED_RE_OBJECTS: 'canchange_archived_reobjects',
	CAN_CHANGE_OTHERS_RE_OBJECTS: 'canchange_others_reobjects',
	CAN_DELETE_RE_OBJECTS: 'candelete_reobjects',
	CAN_SEE_OTHER_RE_OBJECTS: 'cansee_others_reobjects',
	CAN_SEE_OTHER_RE_OBJECTS_DETAILS: 'cansee_others_reobjects_details',
	CAN_USE_PRICED_RE_SERVICES: 'canuse_priced_reservices',
	CAN_ADD_RE_OBJECTS: 'canadd_reobjects',

	CAN_ADD_PROPERTIES: 'canadd_properties',
	CAN_CHANGE_OTHERS_PROPERTIES: 'canchange_otherproperties',

	CAN_APPROVE_VALUATIONS: 'canapprove_valuations',

	CAN_USE_OTHER_USERS_PRICE_LISTS: 'can_use_other_users_price_lists',

	CAN_MANAGE_CUSTOMER_PORTAL_USERS: 'can_manage_customer_portal_users',
	CAN_LINK_CUSTOMER_PORTAL_USER_TO_PROJECT:
		'can_link_customer_portal_user_to_project',

	CAN_ADD_AND_MODIFY_TIMEOFF: 'can_add_and_modify_timeoff',
	CAN_CHANGE_TIMEOFF_FOR_OTHER_USERS: 'can_change_timeoff_for_other_users',
	CAN_SEE_PROJECT_RESOURCING: 'can_see_project_resourcing',
} as const;

export const CustomerPortal = {
	CAN_SEE_ALL_RELATED_FILES: 'can_see_all_related_files',
	CAN_SEE_ALL_PROJECTS: 'can_see_all_projects',
	CAN_SEE_EVENTS_UNDER_PROJECT: 'can_see_events_under_project',
	CAN_SEE_QUOTES_UNDER_PROJECT: 'can_see_quotes_under_project',
	CAN_SEE_ALL_QUOTES: 'can_see_all_quotes',
	CAN_SEE_ORDERS_UNDER_PROJECT: 'can_see_orders_under_project',
	CAN_SEE_ALL_ORDERS: 'can_see_all_orders',
	CAN_SEE_INVOICES_UNDER_PROJECT: 'can_see_invoices_under_project',
	CAN_SEE_ALL_INVOICES: 'can_see_all_invoices',
	CAN_ADD_FILES_UNDER_PROJECTS: 'can_add_files_under_projects',
};

export const PermissionAction = {
	CREATE: 'create',
	READ: 'read',
	MODIFY: 'modify',
	DELETE: 'delete',
	HAS_PERMISSION: 'has_permission',
} as const;
